<template>
    <div class="col-lg-6 col-md-6 col-sm-12" id="company_details_step">
        <div class="collapse-margin collapse-icon" id="company-detail-collapser">
            <div class="card mx-auto">
                <div class="card-header" id="paymentOne1" data-toggle="collapse" role="button" data-target="#company-detail-collapse" aria-expanded="true" aria-controls="company-detail-collapse">
                    <div class="lead collapse-title">
                        <div class="media">
                            <div class="media-body">
                                <div class="row mx-auto">
                                    <p><span class="badge badge-primary badge-glow mr-2">Step 1: </span></p>
                                    <h3 class="text-primary mx-auto">Company Details </h3>
                                </div>
                                <div class="design-group">
                                    <h6 class="section-label">Company Details:</h6>
                                    <div v-if="BusinessStore.business.detail_status">
                                        <div class="badge badge-glow badge-sm mr-0" :class="BusinessStore.business.detail_status?.class">
                                            {{ BusinessStore.business.detail_status?.title }} <i :data-feather="BusinessStore.business.detail_status?.icon"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="company-detail-collapse" class="open" aria-labelledby="paymentOne1" data-parent="#company-detail-collapser">
                    <hr>
                    <div class="card-body">
                        <div class="">
                            <p class="card-text font-medium-2">
                                First thing first is for you to enter your <strong>Company Details</strong>.
                                <br /><br />
                                Your <strong>Companies Details</strong> will be displayed on your clients portal as well is populated
                                in your company documents.<br>
                            </p>
                            <hr>
                        </div>

                        <div class="col-12 d-flex flex-sm-row flex-column justify-content-center">
                            <a href="#" type="submit" class="btn btn-primary mr-sm-1 mb-1 mb-sm-0"
                                data-toggle="modal" data-target="#company_detail_modal_update" v-on:click="showServiceAgreement">
                                Company Details
                            </a>
                            <a href="#" type="submit" data-toggle="modal" data-target="#cf_biz_settings_modal_video"
                                class="btn btn-outline-primary">
                                <i data-feather="film"></i>
                                Tutorial
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, reactive } from 'vue'
import { useUserStore } from '../../../stores/UserStore.js'
import { useBusinessStore } from '../../../stores/BusinessStore.js'
export default{
    setup(){
        const userStore = useUserStore(),
        BusinessStore = useBusinessStore();
        return{
            userStore,BusinessStore
        }
    },
    watch: {
    },
    mounted() {
        
        
    },
    methods:{
        showServiceAgreement(){
            this.BusinessStore.clickedBusinessDetails = true
        }
    }
}
</script>
